import { TimePickerLocale } from '../TimePicker';

const locale: TimePickerLocale = {
  placeholder: '請選擇時間',
};

export default locale;
